// Standalone SVG, one file per toast state. Uses currentColor so the SCSS
// (via --toast-accent) drives the colour — never hardcode a colour here.
const ErrorIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="7.5" />
    <path d="M7 7 L13 13" />
    <path d="M13 7 L7 13" />
  </svg>
)

export default ErrorIcon
